import './Button.css'
import Loading from '../Loading/Loading'

/**
 * Button komponent der kan bruges til at lave forskellige typer knapper
 * @param {string} title - Teksten der vises på knappen
 * @param {function} onClick - Funktion der kaldes når knappen klikkes
 * @param {string} variant - Stilvariant ('contained' eller 'outlined')
 * @param {string} color - Farvevariant ('primary', 'secondary' eller 'danger')
 * @param {object} style - Custom inline styles der skal anvendes på knappen
 * @param {string} className - Custom CSS klasse der skal tilføjes til knappen
 * @param {string} type - Button type ('button', 'submit', 'reset')
 * @param {boolean} disabled - Om knappen er deaktiveret
 */
const Button = ({
    title, 
    onClick, 
    variant = 'contained', 
    color = 'primary', 
    style = {}, 
    className = '', 
    type = 'button', 
    disabled = false, 
    loading = false, 
    loadingText = ''}) => {
    // Variabel til at gemme dynamiske styles
    let buttonStyle = {}

    // Sætter farver baseret på color prop
    if (color === 'secondary') {
        buttonStyle = {
            '--main-button-color': 'var(--secondary-button-color)',
        }
        // For outlined variant skal vi også ændre tekstfarven
        if (variant === 'outlined') {
            buttonStyle['--primary-font-color'] = 'var(--secondary-button-color)';
        }
    }
    if (color === 'confirmation') {
        buttonStyle = {
            '--main-button-color': 'var(--confirmation-button-color)',
        }
        // For outlined variant skal vi også ændre tekstfarven
        if (variant === 'outlined') {
            buttonStyle['--primary-font-color'] = 'var(--confirmation-button-color)';
        }
    }

    // Særlig styling for danger-variant
    if (color === 'danger') {
        buttonStyle = {
            '--main-button-color': 'var(--danger-button-color)',
        }
        if (variant === 'outlined') {
            buttonStyle['--primary-font-color'] = 'var(--danger-button-color)';
        }
    }

    // Sørg for at outlined primary-knapper altid har synlig tekst
    if (variant === 'outlined' && !buttonStyle['--primary-font-color']) {
        buttonStyle['--primary-font-color'] = 'var(--main-button-color)';
    }

    // Kombinerer eksisterende styles med custom styles
    const combinedStyle = { ...buttonStyle, ...style }

    return (
        <button
            className={`button ${variant} ${className}`.trim()} // Tilføjer variant og custom klasse
            onClick={onClick}
            style={combinedStyle}
            type={type}
            disabled={disabled}
        >
            
            {loading ? (
                <span className="button__spinner">
                   <Loading size="small" text={loadingText} />
                </span> 
            ) : (
                <span className={`button__content`}>
                    {title}
                </span>
            )}
        </button>
    )
}

export default Button